import {index, store} from '@/api/comments';

// States.
export const state = {
  revealComments: false,
  artifactDataset: null,
  fetching: false,
  saving: false,
  comments: [],
  comment: ''
}

// Getters.
export const getters = {
  commentsAreVisible: state => state.revealComments === true,
  commentsAreHidden: state => state.revealComments === false,
  fetchingComments: state => state.fetching,
  savingComment: state => state.saving,
  currentComments: state => state.comments,
  currentComment: state => state.comment,
}
// Mutations.
export const mutations = {
  SET_REVEAL_COMMENTS: (state, revealComments) => state.revealComments = revealComments,
  SET_CURRENT_ARTIFACT_DATASET: (state, artifactDataset) => state.artifactDataset = artifactDataset,
  SET_CURRENT_COMMENTS: (state, comments) => state.comments = comments,
  ADD_NEW_COMMENT: (state, comment) => state.comments.unshift(comment),
  SET_FETCHING: (state, fetching) => state.fetching = fetching,
  SET_SAVING: (state, saving) => state.saving = saving,
  SET_CURRENT_COMMENT: (state, comment) => state.comment = comment,
}

// Actions.
export const actions = {
  toggleCommentsVisibility: ({commit, state}) => commit('SET_REVEAL_COMMENTS', !state.revealComments),

  setCurrentComment: ({commit}, comment) => commit('SET_CURRENT_COMMENT', comment),

  fetchComments: async ({commit}, {experiment, artifactDataset}) => {
    commit('SET_REVEAL_COMMENTS', false);
    commit('SET_FETCHING', true);
    commit('SET_CURRENT_ARTIFACT_DATASET', artifactDataset);
    let {data: {data}} = await index({experiment, artifactDataset});
    commit('SET_CURRENT_COMMENTS', data)
    commit('SET_FETCHING', false);
    commit('SET_REVEAL_COMMENTS', true);
  },

  addComment: async ({commit, state}, {experiment}) => {
    commit('SET_SAVING', true);
    let {data: {data}} = await store({experiment, artifactDataset: state.artifactDataset, comment: state.comment});
    commit('ADD_NEW_COMMENT', data);
    commit('SET_CURRENT_COMMENT', '');
    commit('SET_SAVING', false);
  }
}
